import axios from "axios"
import { store } from "../redux/store"
import { API_URL } from "../config";

// import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = ''

//apply base url for axios
const baseUrl = API_URL;
// console.log(store, 'store')

// const getAccessToken = () => store.getState().user.tokens?.access.token


const axiosApi = axios.create({
	baseURL: API_URL,
})

axiosApi.defaults.headers.common["Authorization"] = token

axiosApi.interceptors.response.use(
	response => response,
	error => Promise.reject(error)
)

axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
        // 1. Extract the message from the backend response body
        const errorMessage = error.response?.data?.message;

        // 2. Define the specific messages that should trigger a logout
        const logoutMessages = [
            "Account is inactive",
            "Account does not exist",
            "Please authenticate"
        ];

        // 3. Check if the error message matches any of our logout triggers
        if (logoutMessages.includes(errorMessage)) {
            
            // A. Wipe all browser storage
            localStorage.clear();
            sessionStorage.clear();

            // B. Dispatch the Redux logout action
            // Using your specific slice and action name
            store.dispatch({ type: "userReducer/removeUser" });

            // C. Force redirect to login
            window.location.href = "/";
            
            console.warn(`Logout triggered by backend message: ${errorMessage}`);
        }

        return Promise.reject(error);
    }
);
export async function apiGET(url, config = {}) {
	// let accessToken = getAccessToken()
	let accessToken = localStorage.getItem("accessToken");
	axiosApi.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
	return await axiosApi
		.get(url, { ...config })
		.then(response => response)
		.catch(error => error.response)
}

export async function apiPOST(url, data, config = {}) {
	// let accessToken = getAccessToken() 
	let accessToken = localStorage.getItem("accessToken");
	axiosApi.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
	return axiosApi
		.post(url, { ...data }, { ...config })
		.then(response => response)
		.catch((error) => error.response)
}

export async function apiPUT(url, data, config = {}) {
	// let accessToken = getAccessToken()
	let accessToken = localStorage.getItem("accessToken");
	axiosApi.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
	return axiosApi
		.put(url, { ...data }, { ...config })
		.then(response => response)
		.catch((error) => error.response)
}

export async function apiDELETE(url, config = {}) {
	//let accessToken = getAccessToken()
	let accessToken = localStorage.getItem("accessToken");
	axiosApi.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
	return await axiosApi
		.delete(url, { ...config })
		.then(response => response)
		.catch((error) => error.response)
}

export async function uploadPost(data) {
	const myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");
	// const accessToken = localStorage.getItem("accessToken")
	// myHeaders.append("Authorization", "Bearer " + accessToken);
	const raw = JSON.stringify(data);
	const requestOptions = {
		method: "POST",
		headers: myHeaders,
		body: raw,
		redirect: "follow",
	};
	try {
		const uploadUrl = `${baseUrl}/v1/upload-file`;
		const result = await fetch(uploadUrl, requestOptions);
		const response = await result.json();
		return response.data;
	} catch (err) {
		console.log("err errerr ", err.message);
	}
}